export default __webpack_public_path__ + "static/media/others.de6cf503.svg";